const ZAPBOT_PROMPT_BLOCK_BUTTON_DEFAULT_COPY = "Generate result";
const ZAPBOT_PROMPT_BLOCK_DESCRIPTION =
  "Make custom AI prompts available to your users.";
const ZAPBOT_PROMPT_BLOCK_NAME = "AI Prompt";
const ZAPBOT_PROMPT_BLOCK_ZERO_STATE_DESCRIPTION =
  "Create and connect a ZapBot that takes inputs from users and displays an AI-generated result.";
const ZAPBOT_PROMPT_BLOCK_ZERO_STATE_TITLE = "Connect a ZapBot";
const ZAPBOT_PROMPT_CREATE_ZAPBOT = "Create an AI Prompt";
const ZAPBOT_PROMPT_DATA_PANEL_TITLE = "AI Prompt data";
const ZAPBOT_PROMPT_DATASOURCE_CTA = "Open AI Prompts";
const ZAPBOT_PROMPT_DATASOURCE_NO_RESULTS =
  "You have no AI Prompts to connect. Create an AI Prompt for this component.";
const ZAPBOT_PROMPT_DATASOURCE_TITLE =
  "Select a data source for your AI Prompt";
const ZAPBOT_PROMPT_FIELD_LABEL = "ZapBot";
const ZAPBOT_PROMPT_HELP_TEXT =
  "ZapBots allow you to create prompts that take inputs from users to generate a result.";
const ZAPBOT_PROMPT_LIST_OF_ZAPBOTS = "List of AI Prompts";
const ZAPBOT_PROMPT_OPEN_ZAPBOTS = "Open ZapBots";
const ZAPBOT_PROMPT_SELECT_ZAPBOT = "Select a ZapBot";
const ZAPBOT_PROMPT_SETUP_PANEL_NO_DATASOURCE =
  "You must connect a ZapBot first.";
const ZAPBOT_PROMPT_SETUP_PANEL_TITLE = "AI Prompt setup";
const ZAPBOT_PROMPT_SIDEDRAWER_TITLE = "AI Prompt options";

export const strings = {
  NAME: "AI Prompt",
  DESCRIPTION: "Make custom AI prompts available to your users.",
  ZAPBOT_PROMPT_BLOCK_BUTTON_DEFAULT_COPY,
  ZAPBOT_PROMPT_BLOCK_DESCRIPTION,
  ZAPBOT_PROMPT_BLOCK_NAME,
  ZAPBOT_PROMPT_BLOCK_ZERO_STATE_DESCRIPTION,
  ZAPBOT_PROMPT_BLOCK_ZERO_STATE_TITLE,
  ZAPBOT_PROMPT_CREATE_ZAPBOT,
  ZAPBOT_PROMPT_DATA_PANEL_TITLE,
  ZAPBOT_PROMPT_DATASOURCE_CTA,
  ZAPBOT_PROMPT_DATASOURCE_NO_RESULTS,
  ZAPBOT_PROMPT_DATASOURCE_TITLE,
  ZAPBOT_PROMPT_FIELD_LABEL,
  ZAPBOT_PROMPT_HELP_TEXT,
  ZAPBOT_PROMPT_LIST_OF_ZAPBOTS,
  ZAPBOT_PROMPT_OPEN_ZAPBOTS,
  ZAPBOT_PROMPT_SELECT_ZAPBOT,
  ZAPBOT_PROMPT_SETUP_PANEL_NO_DATASOURCE,
  ZAPBOT_PROMPT_SETUP_PANEL_TITLE,
  ZAPBOT_PROMPT_SIDEDRAWER_TITLE,
} as const;
